// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogsPopularFeed":"jx_a bhe_qr bhe_a bhe_w","BlogsPopularFeed__loading":"jx_b"};